import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { TranslocoService } from '@jsverse/transloco';
import { NotificationService } from './services/notification.service';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const notificationService = inject(NotificationService);
  const transloco = inject(TranslocoService);

  if (req.url.includes('/auth')) {
    return next(req);
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      console.error('Caught by HttpErrorInterceptor:', error);

      const apiCode: number | undefined = error.error?.error?.code;
      if (!(error.error instanceof ErrorEvent) && apiCode !== undefined && apiCode !== null) {
        return throwError(() => error);
      }

      if (error.status === 401) {
        return throwError(() => error);
      }

      let errorMessage: string;
      if (error.error instanceof ErrorEvent || error.status === 0) {
        // status 0 = request never reached a server (offline, CORS, timeout) — same message as
        // an ErrorEvent, and skips building an `errors.http_0` key that will never be translated.
        errorMessage = transloco.translate('errors.network');
      } else {
        const httpKey = `errors.http_${error.status}`;
        const fallback = transloco.translate('errors.http_default', { status: error.status });
        errorMessage = transloco.translate(httpKey) !== httpKey ? transloco.translate(httpKey) : fallback;
      }

      notificationService.show(errorMessage);
      return throwError(() => error);
    }),
  );
};
